__turbopack_context__.v({
  "container": "ExternalTicketsPanel-module-scss-module__tM6wdq__container",
  "content": "ExternalTicketsPanel-module-scss-module__tM6wdq__content",
  "ctaButtonWrapper": "ExternalTicketsPanel-module-scss-module__tM6wdq__ctaButtonWrapper",
  "date": "ExternalTicketsPanel-module-scss-module__tM6wdq__date",
  "headline": "ExternalTicketsPanel-module-scss-module__tM6wdq__headline",
});
